import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Page, Field } from "../components/Primitives";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";

const emptyEmp = { name: "", role: "mechanic", phone: "", email: "", specialization: "", hourly_rate: 0, active: true };
const emptyBay = { name: "", bay_type: "general", active: true };

export default function Employees() {
  const [tab, setTab] = useState("emp");
  const [emps, setEmps] = useState([]);
  const [bays, setBays] = useState([]);
  const [openE, setOpenE] = useState(false);
  const [openB, setOpenB] = useState(false);
  const [formE, setFormE] = useState(emptyEmp);
  const [formB, setFormB] = useState(emptyBay);

  const load = async () => {
    const [e, b] = await Promise.all([api.get("/employees"), api.get("/bays")]);
    setEmps(e.data); setBays(b.data);
  };
  useEffect(() => { load(); }, []);

  const saveE = async (ev) => {
    ev.preventDefault();
    try { await api.post("/employees", { ...formE, hourly_rate: +formE.hourly_rate }); toast.success("Added"); setOpenE(false); setFormE(emptyEmp); load(); }
    catch { toast.error("Failed"); }
  };
  const saveB = async (ev) => {
    ev.preventDefault();
    try { await api.post("/bays", formB); toast.success("Added"); setOpenB(false); setFormB(emptyBay); load(); }
    catch { toast.error("Failed"); }
  };

  const updE = (k) => (e) => setFormE({ ...formE, [k]: e.target.value });
  const updB = (k) => (e) => setFormB({ ...formB, [k]: e.target.value });

  return (
    <Page number="09" title="Team & Bays" subtitle="Technicians, advisors, store-keepers. Bays with capacity and type.">
      <div className="kk-tabs mb-5">
        <button className={"kk-tab " + (tab === "emp" ? "kk-tab-active" : "")} onClick={() => setTab("emp")} data-testid="tab-emp">Employees</button>
        <button className={"kk-tab " + (tab === "bay" ? "kk-tab-active" : "")} onClick={() => setTab("bay")} data-testid="tab-bay">Bays</button>
      </div>
      {tab === "emp" && (
        <>
          <div className="flex justify-end mb-3"><button className="kk-btn-primary" onClick={() => setOpenE(true)} data-testid="add-emp"><Plus size={14}/> Add</button></div>
          <table className="kk-table">
            <thead><tr><th>Name</th><th>Role</th><th>Phone</th><th>Specialization</th><th>Rate/hr</th></tr></thead>
            <tbody>
              {emps.map((e) => (
                <tr key={e.id}><td>{e.name}</td><td><span className="kk-pill kk-pill-muted">{e.role}</span></td><td>{e.phone}</td><td>{e.specialization}</td><td className="font-mono">₹{e.hourly_rate || 0}</td></tr>
              ))}
              {emps.length === 0 && <tr><td colSpan={5} className="text-center py-8 text-[var(--kk-muted)]">No team members.</td></tr>}
            </tbody>
          </table>
        </>
      )}
      {tab === "bay" && (
        <>
          <div className="flex justify-end mb-3"><button className="kk-btn-primary" onClick={() => setOpenB(true)} data-testid="add-bay"><Plus size={14}/> Add Bay</button></div>
          <table className="kk-table">
            <thead><tr><th>Name</th><th>Type</th><th>Active</th></tr></thead>
            <tbody>
              {bays.map((b) => (
                <tr key={b.id}><td>{b.name}</td><td>{b.bay_type}</td><td>{b.active ? "✓" : "—"}</td></tr>
              ))}
              {bays.length === 0 && <tr><td colSpan={3} className="text-center py-8 text-[var(--kk-muted)]">No bays.</td></tr>}
            </tbody>
          </table>
        </>
      )}

      {openE && (
        <div className="fixed inset-0 bg-black/30 z-50 flex justify-end" onClick={() => setOpenE(false)}>
          <form onSubmit={saveE} onClick={(e) => e.stopPropagation()} className="w-full max-w-md bg-[var(--kk-surface)] p-8 overflow-y-auto">
            <div className="flex items-center justify-between"><h2 className="font-display text-2xl uppercase">Add Employee</h2><button type="button" onClick={() => setOpenE(false)}><X/></button></div>
            <div className="grid grid-cols-2 gap-5 mt-5">
              <div className="col-span-2"><Field label="Name *"><input className="kk-input" required value={formE.name} onChange={updE("name")} /></Field></div>
              <Field label="Role"><select className="kk-input" value={formE.role} onChange={updE("role")}><option value="mechanic">Mechanic</option><option value="advisor">Advisor</option><option value="storekeeper">Store Keeper</option><option value="accountant">Accountant</option><option value="admin">Admin</option></select></Field>
              <Field label="Phone"><input className="kk-input" value={formE.phone} onChange={updE("phone")} /></Field>
              <Field label="Email"><input className="kk-input" type="email" value={formE.email} onChange={updE("email")} /></Field>
              <Field label="Rate/hr"><input className="kk-input" type="number" value={formE.hourly_rate} onChange={updE("hourly_rate")} /></Field>
              <div className="col-span-2"><Field label="Specialization"><input className="kk-input" value={formE.specialization} onChange={updE("specialization")} /></Field></div>
            </div>
            <button className="kk-btn-primary mt-6" type="submit">Save</button>
          </form>
        </div>
      )}
      {openB && (
        <div className="fixed inset-0 bg-black/30 z-50 flex justify-end" onClick={() => setOpenB(false)}>
          <form onSubmit={saveB} onClick={(e) => e.stopPropagation()} className="w-full max-w-md bg-[var(--kk-surface)] p-8 overflow-y-auto">
            <div className="flex items-center justify-between"><h2 className="font-display text-2xl uppercase">Add Bay</h2><button type="button" onClick={() => setOpenB(false)}><X/></button></div>
            <div className="grid grid-cols-2 gap-5 mt-5">
              <div className="col-span-2"><Field label="Name *"><input className="kk-input" required value={formB.name} onChange={updB("name")} /></Field></div>
              <Field label="Type"><select className="kk-input" value={formB.bay_type} onChange={updB("bay_type")}><option value="general">General</option><option value="wheel-align">Wheel Alignment</option><option value="detail">Detailing</option><option value="wash">Wash</option></select></Field>
            </div>
            <button className="kk-btn-primary mt-6" type="submit">Save</button>
          </form>
        </div>
      )}
    </Page>
  );
}
